import { FC } from 'react'

import { DateRangeDialog } from '@ui/forms/input-field/date/date-range-picker/dialog/date-range-dialog';
import { DateRangeValue } from '@ui/forms/input-field/date/date-range-picker/date-range-value';

import { useDateRangePickerState } from '@ui/forms/input-field/date/date-range-picker/use-date-range-picker-state';
import { useIsMobileMediaQuery } from '@ui/utils/hooks/is-mobile-media-query';

export interface ReleasedDateRangeProps {
    value: DateRangeValue | null
    onChange?: (value: DateRangeValue | null) => void
}

export const ReleasedDateRange: FC<ReleasedDateRangeProps> = ({ value, onChange }) => {
    const isMobile = useIsMobileMediaQuery()

    const state = useDateRangePickerState({
        granularity: 'minute',
        defaultValue: {
            start: value?.start,
            end: value?.end,
            preset: value?.preset,
        },
        closeDialogOnSelection: false,
        onChange: (payload) => onChange?.(payload)
    })

    return (
        <>
            <DateRangeDialog
               state={state}
               showInlineDatePickerField={!isMobile}
            />
        </>
    )
}
